import {Directive, HostListener} from '@angular/core';
import * as screenfull from 'screenfull';
 
@Directive({
    selector: '[toggleFullscreen]'
})
export class ToggleFullscreenDirective {
    constructor() { }

    @HostListener('click', ['$event']) 
    toggleFullScreen($event:any) {
        if (screenfull.enabled) {
            screenfull.toggle();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/directives/fullscreen/fullscreen.directive.ts